import React, { useEffect, useState } from 'react';
import s from './LatestComments.module.css';
import { useSelector } from 'react-redux';
import { selectComments } from '../../../../store/selectors/dashboardSelectors';
import { useAppDispatch } from '../../../../store/store';
import { fetchLatestComments } from '../../../../shared/api/dashboardApi';

import { selectUser } from '../../../../store/selectors/authSelectors';
import { selectSelectedSocialMedia } from '../../../../store/selectors/projectSelectors';
type Comment = {
    id: string;
    author: string;
    text: string;
    provider?: string;
    post_id?: string;
    created_at?: string;
};

const LatestComments: React.FC = () => {
    const comments = useSelector(selectComments);
    const socialMedia = useSelector(selectSelectedSocialMedia);
    const dispatch = useAppDispatch();
    const user = useSelector(selectUser);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (socialMedia && user !== null) {
            const getComments = async () => {
                const endDate = new Date().toISOString().split('T')[0];
                const startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
                    .toISOString()
                    .split('T')[0];
                setIsLoading(true);
                await dispatch(
                    fetchLatestComments({
                        platform: socialMedia,
                        startDate,
                        endDate,
                    }),
                );
            };
            getComments();
            setIsLoading(false);
        }
    }, [dispatch, socialMedia, user]);

    if (!socialMedia) {
        return (
            <div className={s.container}>
                <p className={s.title}>Latest comments</p>
                <p className={s.noComments}>Select a platform to view comments</p>
            </div>
        );
    }

    return (
        <div className={s.container}>
            <p className={s.title}>Latest comments</p>
            <div className={s.list}>
                {comments.length === 0 ? (
                    <p className={s.noComments}>No comments found for {socialMedia}</p>
                ) : (
                    comments.map((comment: Comment) => (
                        <div key={comment.id} className={s.item}>
                            <div className={s.author}>{comment.author}</div>
                            <div className={s.comment}>{comment.text}</div>
                            {comment.created_at && (
                                <div className={s.date}>
                                    {new Date(comment.created_at).toLocaleDateString()}
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default LatestComments;
